import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Field, ErrorMessage, getIn, Formik, Form } from 'formik'
import { toastr } from 'react-redux-toastr'
import { messageService } from '../_services/message.service'
import * as Yup from 'yup'
import NumberFormat from 'react-number-format'
import UnionSelect from '../_components/Shared/UnionSelect'
import ErrorPopUp from '../_components/Shared/ErrorPopUp'
import Step1 from './Step1'

class RegisterForm extends Component {
  state = {
    currentStep: 0,
    lastStep: 0
  }

  prevStep = props => {
    // Prev Step dont undes 0
    this.setState(state => ({
      currentStep: Math.max(state.currentStep - 1, 0)
    }))
    props.setTouched({})
  }

  nextStep = props => {
    // console.log(props.values);

    // Next Step dont go over Max step
    // console.log(props.errors);
    // props.submitForm().then(() => {
    if (props.isValid) {
      this.setState(state => ({
        currentStep: Math.min(state.currentStep + 1, state.lastStep)
      }))
      // props.validateForm();
      props.setTouched({})
    }
    // });
  }

  Step1Schema = Yup.object().shape({
    firstName: Yup.string()
      .matches(
        /^[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\(\)\[\]\{\}.,،;\-؛]+$/,
        {
          message: 'لطفا فقط از حروف فارسی استفاده کنید',
          excludeEmptyString: false
        }
      )
      .test('len', 'نام وارد شده نا معتبر است', val => val && val.length > 1)
      .required('وارد کردن [نام] الزامی است'),

    lastName: Yup.string()
      .matches(
        /^[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\(\)\[\]\{\}.,،;\-؛]+$/,
        {
          message: 'لطفا فقط از حروف فارسی استفاده کنید',
          excludeEmptyString: false
        }
      )
      .test(
        'len',
        'نام خانوادگی وارد شده نا معتبر است',
        val => val && val.length > 1
      )
      .required('وارد کردن [نام خانوادگی] الزامی است'),

    mobile: Yup.string()
      .matches(/(\+98|0)?9\d{9}/, {
        message: 'شماره موبایل وارد شده نامعتبر است',
        excludeEmptyString: false
      })
      .required('وارد کردن [شماره موبایل] الزامی است'),

    message: Yup.string()
      .matches(
        /^[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\d\(\)\[\]\{\}.,،;\-؛]+$/,
        {
          message: 'لطفا فقط از حروف فارسی استفاده کنید',
          excludeEmptyString: false
        }
      )
      .trim()
      .test('len', 'پیام وارد شده نا معتبر است', val => val && val.length > 3)
      .required('وارد کردن [پیام] الزامی است')
  })

  schemaArray = [this.Step1Schema, this.Step2Schema, this.Step3Schema]

  handleSubmit = (values, formikbag) => {
    // do stuff
    setTimeout(() => {
      formikbag.setSubmitting(false)
    }, 1000)
  }

  step1 = props => {
    if (this.state.currentStep == 0) {
      return (
        <div>
          <Step1 {...props} />
          {/* <br/>
          <button className="nextButton pull-right" onClick={() => { this.nextStep(props) }}>
            مرحله بعد
          </button> */}
        </div>
      )
    }
  }

  //   step2 = props => {
  //     if (this.state.currentStep == 1) {
  //       return (
  //         <div>
  //         <Step2 {...props} />
  //           <br/>
  //           <button className="nextButton pull-right" onClick={() => { this.nextStep(props) }}>
  //             مرحله بعد
  //           </button>
  //           <button className="previousButton pull-right" onClick={() => { this.prevStep(props) }}>
  //             مرحله قبل
  //           </button>
  //         </div>
  //       );
  //     }
  //   };

  //   step3 = props => {
  //     if (this.state.currentStep == 2) {
  //       return (
  //         <div>
  //         <Step3 {...props} />
  //           <br/>
  //           <button className="nextButton pull-right" type="submit">
  //             ذخیره
  //           {props.isSubmitting &&
  //                     <i className="mdi mdi-24px mdi-spin mdi-loading"></i>
  //                     }
  //           </button>
  //           <button className="previousButton pull-right" onClick={() => { this.prevStep(props) }}>
  //           مرحله قبل
  //           </button>
  //         </div>
  //       );
  //     }
  //   };

  handleSubmit = values => {
    values['messageStatus'] = 0
    // console.log(JSON.stringify(values));

    this.setState({ loading: true })
    messageService
      .add(JSON.stringify(values))
      .then(res => {
        // console.log(res);

        this.setState({ loading: false })
        toastr.success('ثبت پیام', 'پیام شما با موفقیت ثبت شد')
      })
      .catch(error => {
        console.log(error)
      })
  }

  render() {
    const { currentStep, loading } = this.state
    const { prevStep, nextStep, schemaArray } = this
    return (
      <div className="contact-form">
        <div className="header">
          <h1>ﺗﻤﺎس ﺑﺎ واﺣﺪ آﻣﻮزش اﺗﺎق اﺻﻨﺎف ﺗﻬﺮان</h1>
          <p>
            در ﺻﻮرت ﻫﺮﮔﻮﻧﻪ ﺳﻮال،ﭘﯿﻨﺸﻬﺎد و اﻧﺘﻘﺎد از ﻫﻤﯿﻦ ﻃﺮﯾﻖ ﭘﯿﺎم ﺧﻮد را ارﺳﺎل
            ﻧﻤﺎﯾﯿﺪ
          </p>
        </div>

        <br />
        <Formik
          onSubmit={(values, { setSubmitting }) => {
            // console.log(values);
            this.handleSubmit(values)
            setSubmitting(false)
          }}
          enableReinitialize
          initialValues={{
            firstName: '',
            lastName: '',
            mobile: '',
            email: '',
            message: ''
          }}
          validationSchema={schemaArray[currentStep]}>
          {props => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit
            } = props
            return (
              <Form>
                <div className="row">
                  <div className="col-md-10 col-md-offset-1">
                    <div className="form-inline">
                      <div className="col-md-6">
                        <Field
                          type="text"
                          placeHolder="* ﻧﺎم"
                          value={values.firstName}
                          onBlur={handleBlur}
                          name="firstName"
                          touched={touched.firstName}
                          className={
                            getIn(errors, 'firstName') &&
                            getIn(touched, 'firstName')
                              ? 'text-input has-error rtl'
                              : 'text-input required rtl'
                          }
                        />
                        {getIn(errors, 'firstName') &&
                        getIn(touched, 'firstName') ? (
                          <div className={'required_validator visible'}>
                            <div className="validator_container">
                              <span>{errors.firstName}</span>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      <div className="col-md-6">
                        <Field
                          type="text"
                          placeHolder="* ﻧﺎم خانوادگی"
                          value={values.lastName}
                          onBlur={handleBlur}
                          name="lastName"
                          touched={touched.lastName}
                          className={
                            getIn(errors, 'lastName') &&
                            getIn(touched, 'lastName')
                              ? 'text-input has-error rtl'
                              : 'text-input required rtl'
                          }
                        />
                        {getIn(errors, 'lastName') &&
                        getIn(touched, 'lastName') ? (
                          <div className={'required_validator visible'}>
                            <div className="validator_container">
                              <span>{errors.lastName}</span>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      <div className="clearfix" />

                      <div className="col-md-6">
                        <Field
                          type="text"
                          placeHolder="* موبایل"
                          value={values.mobile}
                          onBlur={handleBlur}
                          name="mobile"
                          touched={touched.mobile}
                          className={
                            getIn(errors, 'mobile') && getIn(touched, 'mobile')
                              ? 'text-input has-error rtl'
                              : 'text-input required rtl'
                          }
                        />
                        {getIn(errors, 'mobile') && getIn(touched, 'mobile') ? (
                          <div className={'required_validator visible'}>
                            <div className="validator_container">
                              <span>{errors.mobile}</span>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      <div className="col-md-6">
                        <Field
                          type="text"
                          placeHolder="ایمیل"
                          value={values.email}
                          onBlur={handleBlur}
                          name="email"
                          touched={touched.email}
                          className={
                            getIn(errors, 'email') && getIn(touched, 'email')
                              ? 'text-input has-error rtl'
                              : 'text-input required rtl'
                          }
                        />
                        {getIn(errors, 'email') && getIn(touched, 'email') ? (
                          <div className={'required_validator visible'}>
                            <div className="validator_container">
                              <span>{errors.email}</span>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      <div className="clearfix" />

                      <div className="col-md-12">
                        <Field
                          name="message"
                          rows="10"
                          render={({ field }) => (
                            <textarea
                              {...field}
                              placeHolder="* ﭘﯿﺎم ﺧﻮد را وارد ﻧﻤﺎﯾﯿﺪ"
                              value={values.message}
                              className={
                                getIn(errors, 'message') &&
                                getIn(touched, 'message')
                                  ? 'textarea has-error rtl'
                                  : 'textarea required rtl'
                              }
                            />
                          )}
                        />

                        {getIn(errors, 'message') &&
                        getIn(touched, 'message') ? (
                          <div className={'required_validator visible'}>
                            <div className="validator_container">
                              <span>{errors.message}</span>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className="clearfix" />

                      <div className="col-md-12">
                        <button className="contactBtn pull-right">
                          &nbsp; ارسال پیام &nbsp;
                          {loading && (
                            <i className="mdi mdi-spin mdi-loading" />
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
    )
  }
}

export default RegisterForm
